import { Box } from '@chakra-ui/react';
import styled from '@emotion/styled';

// the hr element renders inconsistently, specially when there are a few together
// some could be one pixel

export const Divider = ({ borderColor = 'neutral.EBEFF3', ...props }) => (
  <Box borderBottom="1px solid" borderColor={borderColor} {...props} />
);

// the hr element renders inconsistently, specially when there are a few together
// some could be one pixel
export const DividerColoredGradient = styled(Box)`
  border-bottom: 1px solid ${({ theme, ...props }) => props?.borderColor ?? theme.colors.neutral.EBEFF3};
  border-image-slice: 1;
  border-image-source: ${({ theme, ...props }) => props?.borderImageSource};
`;
